import React, { useState, useEffect } from 'react'
import ImportSpareParts from 'src/pages/ReportsPages/ReportsBoard/SpareParts/ImportSpareParts'
import boardReportsService from 'src/services/boardReportsService'

const ImportsSparePartsContainer = () => {
  const [selectedDate, setSelectedDate] = useState(new Date())
  const [total1, setTotal1] = useState([])
  const [gTotal1, setGTotal1] = useState([])
  const [total2, setTotal2] = useState([])
  const [total3, setTotal3] = useState([])
  const [total4, setTotal4] = useState([])

  const reloadImportsTotal = async () => {
    const [query1, gQuery1, query2, query3, query4] = await Promise.all([
      boardReportsService.getTotalImports('1', selectedDate.getFullYear()),
      boardReportsService.getGTotalImports('1', selectedDate.getFullYear()),
      boardReportsService.getTotalImports('2', selectedDate.getFullYear()),
      boardReportsService.getTotalImports('3', selectedDate.getFullYear()),
      boardReportsService.getTotalImports('4', selectedDate.getFullYear()),
    ])
    setTotal1(query1)
    setGTotal1(gQuery1)
    setTotal2(query2)
    setTotal3(query3)
    setTotal4(query4)
  }

  const handleDateChange = value => {
    setSelectedDate(value)
  }

  useEffect(() => {
    reloadImportsTotal()
  }, [])

  return (
    <ImportSpareParts
      total1={total1}
      total2={total2}
      total3={total3}
      total4={total4}
      gTotal1={gTotal1}
      handleDateChange={handleDateChange}
      selectedDate={selectedDate}
    />
  )
}

export default ImportsSparePartsContainer
